<template>
    <div
        class="ExclusiveTitle_wrap"
        v-if="isShowHeader"
    >
        <p>
            <span class="Exclusive_Title">{{ExclusiveTitle}}</span>
            <span
                class="Exclusive_subTitle"
                v-if="subTitle"
            >{{subTitle}}</span>
        </p>
        <p
            v-if="moreJumpUrl"
            @click="jumpMorePage"
            class="Exclusive_moreBtn"
        >{{isShowMoreBtnText}}</p>
    </div>
</template>
<script>
export default {
    name: 'ExclusiveTitle',
    props: {
        ExclusiveTitle: {
            type: String,
            default: '限时免息'
        },
        subTitle: {
            type: String,
            default: ''
        },
        // isShowMoreBtn: {
        //     type: Boolean,
        //     default: true
        // },
        isShowMoreBtnText: {
            type: String,
            default: '查看更多'
        },
        isShowHeader: {
            type: Boolean,
            default: true
        },
        moreJumpUrl: {
            type: String,
            default: ''
        }
    },
    methods: {
        jumpMorePage() {
            if (this.moreJumpUrl) {
                window.location.href = this.moreJumpUrl;
            }
            this.$emit('jumpMorePage');
        }
    }
};
</script>
<style lang="scss">
@import '@/scss/mixin.scss';
.ExclusiveTitle_wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: $rem28;
    .Exclusive_Title {
        font-size: $rem40;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
    }
    .Exclusive_subTitle {
        margin-left: $rem10;
    }
    .Exclusive_moreBtn,
    .Exclusive_subTitle {
        font-size: $rem24;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
    }
}
</style>
